import type { Media } from "./types";

/**
 * Adapt a legacy `photos: string[]` (mobile v1, plain image URLs) into
 * the richer Media[] shape MediaViewer / MediaGallery consume. Mime is
 * hardcoded as `image/jpeg` since the historical column doesn't carry
 * one — the viewer renders all images the same way anyway.
 */
export function photosToMedia(urls: string[] | undefined | null): Media[] {
  return (urls ?? []).map((url) => ({
    url,
    kind: "photo",
    mime: "image/jpeg",
  }));
}
